(function() {
  var TEST_QUERY = "a=1&a=2&widget_id=abc";
  var EXPECTED_ENTRIES = [
    ["a", "1"],
    ["a", "2"],
    ["widget_id", "abc"]
  ];

  function iteratorFromEntries(entries) {
    var index = 0;
    var iterator = {
      next: function() {
        if (index >= entries.length) return { done: true };

        var value = entries[index];
        index += 1;
        return { value: value, done: false };
      }
    };

    iterator[Symbol.iterator] = function() {
      return this;
    };

    return iterator;
  }

  function entriesFromForEach(searchParams) {
    var entries = [];
    searchParams.forEach(function(value, name) {
      entries.push([name, value]);
    });
    return iteratorFromEntries(entries);
  }

  function entriesMethod() {
    return entriesFromForEach(this);
  }

  function entriesEqual(entries) {
    if (!entries || entries.length !== EXPECTED_ENTRIES.length) return false;

    for (var index = 0; index < EXPECTED_ENTRIES.length; index += 1) {
      if (entries[index][0] !== EXPECTED_ENTRIES[index][0]) return false;
      if (entries[index][1] !== EXPECTED_ENTRIES[index][1]) return false;
    }

    return true;
  }

  function entriesByForOf(searchParams) {
    var entries = [];

    for (var entry of searchParams) {
      var name = entry[0];
      var value = entry[1];
      entries.push([name, value]);
    }

    return entries;
  }

  function entriesExcludingFiles(requestBody) {
    var entries = [];

    for (var entry of requestBody) {
      var name = entry[0];
      var value = entry[1];
      if (typeof File !== "undefined" && value instanceof File) continue;
      entries.push([name, value]);
    }

    return entries;
  }

  function turboLikePathWorks(requestBody) {
    var reconstructed;

    if (Array.from(requestBody).length > 0) {
      reconstructed = new URLSearchParams(entriesExcludingFiles(requestBody));
    } else {
      reconstructed = requestBody;
    }

    return entriesEqual(entriesByForOf(reconstructed));
  }

  function urlSearchParamsProbeWorks() {
    var params = new URLSearchParams(TEST_QUERY);

    return (
      entriesEqual(entriesByForOf(params)) &&
      turboLikePathWorks(params)
    );
  }

  function urlSearchParamsMethodWorks(params, methodName) {
    if (typeof params[methodName] !== "function") return false;

    return entriesEqual(Array.from(params[methodName]()));
  }

  function urlSearchParamsIteratorWorks(params) {
    if (typeof params[Symbol.iterator] !== "function") return false;

    return entriesEqual(entriesByForOf(params));
  }

  function urlSearchParamsWorks() {
    return urlSearchParamsProbeWorks();
  }

  function urlSearchParamsWorksSafely() {
    try {
      return urlSearchParamsWorks();
    } catch (error) {
      return false;
    }
  }

  function urlSearchParamsFromURLWorks() {
    if (typeof URL === "undefined") return true;

    var url = new URL("https://example.test/frame?" + TEST_QUERY);

    return (
      entriesEqual(entriesByForOf(url.searchParams)) &&
      turboLikePathWorks(url.searchParams)
    );
  }

  function urlSearchParamsFromURLWorksSafely() {
    try {
      return urlSearchParamsFromURLWorks();
    } catch (error) {
      return false;
    }
  }

  function defineValue(object, name, value) {
    Object.defineProperty(object, name, {
      configurable: true,
      writable: true,
      value: value
    });
  }

  function patchIterableSurface(prototype, sample) {
    if (!prototype || !sample || typeof sample.forEach !== "function") return;

    if (!urlSearchParamsMethodWorks(sample, "entries")) {
      defineValue(prototype, "entries", entriesMethod);
    }

    if (!urlSearchParamsIteratorWorks(sample)) {
      defineValue(prototype, Symbol.iterator, prototype.entries);
    }
  }

  function patchURLSearchParamsPrototype() {
    var sample = new URLSearchParams(TEST_QUERY);
    patchIterableSurface(URLSearchParams.prototype, sample);
  }

  function patchURLSearchParamsFromURLPrototype() {
    if (typeof URL === "undefined" || typeof Object.getPrototypeOf !== "function") return;

    var url = new URL("https://example.test/frame?" + TEST_QUERY);
    var searchParamsPrototype = Object.getPrototypeOf(url.searchParams);

    if (searchParamsPrototype === URLSearchParams.prototype) return;

    patchIterableSurface(searchParamsPrototype, url.searchParams);
  }

  if (
    typeof Symbol === "undefined" ||
    !Symbol.iterator ||
    typeof URLSearchParams === "undefined" ||
    !URLSearchParams.prototype ||
    typeof URLSearchParams.prototype.forEach !== "function" ||
    typeof Object === "undefined" ||
    typeof Object.defineProperty !== "function"
  ) {
    return;
  }

  try {
    if (!urlSearchParamsWorks()) {
      patchURLSearchParamsPrototype();
    }

    if (!urlSearchParamsFromURLWorks()) {
      patchURLSearchParamsFromURLPrototype();
    }

    if (!urlSearchParamsWorksSafely() || !urlSearchParamsFromURLWorksSafely()) {
      patchURLSearchParamsPrototype();
      patchURLSearchParamsFromURLPrototype();
    }
  } catch (error) {
    try {
      patchURLSearchParamsPrototype();
      patchURLSearchParamsFromURLPrototype();
    } catch (patchError) {
      // Old native prototypes can reject mutation. Leave the runtime untouched.
    }
  }
})();
